var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLayer1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1815",
    "data-name": "Group 1815",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 31.648,
    viewBox: "0 0 26 31.648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3884",
    "data-name": "Path 3884",
    d: "M3.426,7.8H2.687V14.34a1.424,1.424,0,0,1-1.046,1.244,1.28,1.28,0,0,1-1.406-.577A1.19,1.19,0,0,1,0,14.485q0-1.028,0-2.055V7.02A3.606,3.606,0,0,1,2.055,3.793,2.488,2.488,0,0,1,3.3,3.45H9.448a3.606,3.606,0,0,1,3.426,2.488A1.8,1.8,0,0,1,13,6.551v7.735a1.316,1.316,0,0,1-1.641,1.28,1.226,1.226,0,0,1-.938-1.154q0-1.352,0-2.7V7.8H9.61V27.719a1.136,1.136,0,0,1-.685.992,1.334,1.334,0,0,1-1.713-.379.631.631,0,0,1-.126-.361c0-.613-.09-1.226-.09-1.8V16.594H6.148V27.7A1.172,1.172,0,0,1,5.3,28.783a1.208,1.208,0,0,1-1.316-.27,1.262,1.262,0,0,1-.451-1.01V7.8Z",
    transform: "translate(0 2.774)",
    fill: "#f7921f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3885",
    "data-name": "Path 3885",
    d: "M2.21,2.562A2.542,2.542,0,0,1,4.879,0,2.6,2.6,0,0,1,7.241,2,2.553,2.553,0,0,1,2.318,3.337a5.68,5.68,0,0,1-.108-.775Z",
    transform: "translate(1.775 0.002)",
    fill: "#f7921f"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2",
    transform: "translate(13 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3884-2",
    "data-name": "Path 3884",
    d: "M3.426,7.8H2.687V14.34a1.424,1.424,0,0,1-1.046,1.244,1.28,1.28,0,0,1-1.406-.577A1.19,1.19,0,0,1,0,14.485q0-1.028,0-2.055V7.02A3.606,3.606,0,0,1,2.055,3.793,2.488,2.488,0,0,1,3.3,3.45H9.448a3.606,3.606,0,0,1,3.426,2.488A1.8,1.8,0,0,1,13,6.551v7.735a1.316,1.316,0,0,1-1.641,1.28,1.226,1.226,0,0,1-.938-1.154q0-1.352,0-2.7V7.8H9.61V27.719a1.136,1.136,0,0,1-.685.992,1.334,1.334,0,0,1-1.713-.379.631.631,0,0,1-.126-.361c0-.613-.09-1.226-.09-1.8V16.594H6.148V27.7A1.172,1.172,0,0,1,5.3,28.783a1.208,1.208,0,0,1-1.316-.27,1.262,1.262,0,0,1-.451-1.01V7.8Z",
    transform: "translate(0 2.774)",
    fill: "#f7921f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3885-2",
    "data-name": "Path 3885",
    d: "M2.21,2.562A2.542,2.542,0,0,1,4.879,0,2.6,2.6,0,0,1,7.241,2,2.553,2.553,0,0,1,2.318,3.337a5.68,5.68,0,0,1-.108-.775Z",
    transform: "translate(1.775 0.002)",
    fill: "#f7921f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer1);
export default __webpack_public_path__ + "static/media/Layer1.ee73b0cc7ceff8a62ea59ee4e897e29c.svg";
export { ForwardRef as ReactComponent };